<template>
    <div>
        <Loading :loading="loading"/>
        <Edit
            :entidade="entidadeSelecionada"
            :contexto="contextoSelecionado"
            :campos="camposEditados"
            :formatos="formatos"
            :sistemas="sistemas"
            :close="closeEdit"
            :onSubmit="onSubmit"
        />
        <CAlert show color="light">
            Campos adicionais permitem adicionar informações extras nos formulários dos sistemas Versotech.
            Organize por entidade e contexto onde o campo será exibido.
        </CAlert>

        <div class="entidades-grid">
            <div
                v-for="(entidade, chaveEntidade) in entidades"
                :key="chaveEntidade"
                class="entidade-card"
            >
                <div class="entidade-header">
                    <div class="entidade-icon">
                        <fa-icon :icon="getIconeEntidade(chaveEntidade)" />
                    </div>
                    <div class="entidade-info">
                        <div class="entidade-nome">{{ entidade.titulo }}</div>
                        <div class="entidade-desc">{{ Object.keys(entidade.contextos).length }} contexto(s)</div>
                    </div>
                </div>

                <div class="contextos-list">
                    <div
                        v-for="(contexto, chaveContexto) in (entidade.contextos || {})"
                        :key="chaveContexto"
                        class="contexto-item"
                        @click="openEdit(chaveEntidade, chaveContexto, contexto)"
                    >
                        <div class="contexto-info">
                            <div class="contexto-nome">{{ contexto.titulo }}</div>
                            <div class="contexto-desc">{{ contexto.descricao }}</div>
                        </div>
                        <div class="contexto-meta">
                            <span class="badge-campos">
                                {{ getQtdCampos(chaveEntidade, chaveContexto) }} campo(s)
                            </span>
                            <fa-icon icon="pencil-alt" class="contexto-edit-icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { get, put } from '../../helpers/apiRequest';
  import clone from "just-clone";
  import Edit from "./components/Edit.vue";

  export default {
    name: "CamposAdicionais",
    components: {
      Edit
    },
    data() {
      return {
        loading: false,
        entidades: {},
        formatos: [],
        sistemas: [],
        campos: {},
        entidadeSelecionada: {},
        contextoSelecionado: {},
        camposEditados: [],
      };
    },
    methods: {
      getIconeEntidade(chave) {
        const icones = {
          cliente: 'user',
          orcamento: 'clipboard-list',
        };
        return icones[chave] || 'cogs';
      },
      getSistemaLabel(chave) {
        const sis = this.sistemas.find(s => s.chave === chave);
        return sis ? sis.label : chave;
      },
      getQtdCampos(entidade, contexto) {
        const chave = `${entidade}.${contexto}`;
        return this.campos[chave] ? this.campos[chave].length : 0;
      },
      openEdit(chaveEntidade, chaveContexto, contexto) {
        this.entidadeSelecionada = {
          chave: chaveEntidade,
          titulo: this.entidades[chaveEntidade].titulo,
          ordem_por_vinculo: this.entidades[chaveEntidade].ordem_por_vinculo || false,
        };
        this.contextoSelecionado = {
          chave: chaveContexto,
          titulo: contexto.titulo,
          descricao: contexto.descricao,
          sistemas_disponiveis: contexto.sistemas_disponiveis || [],
        };
        const chave = `${chaveEntidade}.${chaveContexto}`;
        this.camposEditados = this.campos[chave] ? clone(this.campos[chave]) : [];
        this.$modal.show('editCampoAdicional');
      },
      closeEdit() {
        this.$modal.hide('editCampoAdicional');
      },
      loadEntidades() {
        get('/admin/entidades-campos-adicionais')
          .then((response) => this.entidades = response);
      },
      loadCampos() {
        get('/admin/campos-adicionais')
          .then((response) => this.campos = response);
      },
      loadFormatos() {
        get('/admin/formatos-campos-adicionais')
          .then((response) => this.formatos = response);
      },
      loadSistemas() {
        get('/admin/sistemas-campos-adicionais')
          .then((response) => this.sistemas = response);
      },
      onSubmit(campos) {
        this.loading = true;
        const entidade = this.entidadeSelecionada.chave;
        const contexto = this.contextoSelecionado.chave;

        put(`/admin/campos-adicionais/${entidade}/${contexto}`, campos)
          .then((response) => {
            this.$swal({
              title: 'Sucesso!',
              text: response.message,
              icon: 'success',
            });
            this.loadCampos();
            this.closeEdit();
            this.loading = false;
          })
          .catch((err) => {
            this.$swal({
              title: 'Ops!',
              text: err.message,
              icon: 'error',
            });
            this.loading = false;
          });
      },
    },
    beforeMount() {
      this.loadEntidades();
      this.loadCampos();
      this.loadFormatos();
      this.loadSistemas();
    },
  }
</script>

<style scoped>
.entidades-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  margin-top: 16px;
}

.entidade-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.entidade-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.entidade-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eceaf3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3a3e81;
  font-size: 16px;
  flex-shrink: 0;
}

.entidade-nome {
  font-weight: 600;
  font-size: 15px;
  color: #1d2939;
}

.entidade-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
}

.contextos-list {
  padding: 8px 0;
}

.contexto-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.15s;
}

.contexto-item:hover {
  background: #f9fafb;
}

.contexto-nome {
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}

.contexto-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
}

.contexto-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.badge-sistema {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 10px;
  background: #eceaf3;
  color: #3a3e81;
}

.badge-campos {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #d0d5dd;
  color: #667085;
  background: #f9fafb;
}

.contexto-edit-icon {
  color: #98a2b3;
  font-size: 13px;
  transition: color 0.15s;
}

.contexto-item:hover .contexto-edit-icon {
  color: #3a3e81;
}
</style>
